import React, { useState, useEffect, useContext } from "react";
import { PermissionContext } from "../../contexts/PermissionContext";
import { AuthContext } from "../../contexts/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import Notification from "../../components/UI/Notification";
import RolePermissionsForm from "../Roles/components/RolePermissionsForm";
import { getRoleBasedRoute } from "../../utils/routeUtils";
import { FaArrowLeft } from "react-icons/fa";

const EditPermission = () => {
  const { id: permissionId } = useParams();
  const navigate = useNavigate();
  const { token, roles: userRoles } = useContext(AuthContext);
  const { currentPermission, fetchPermissionDetails, editPermission } =
    useContext(PermissionContext);

  const [hasFetched, setHasFetched] = useState(false);
  const [notification, setNotification] = useState(null);

  const getRoleBasedRouteLocal = (route) => {
    if (!userRoles || userRoles.length === 0) return route;
    return getRoleBasedRoute(route, userRoles);
  };

  useEffect(() => {
    const fetchDetails = async () => {
      if (!hasFetched && token && permissionId) {
        try {
          await fetchPermissionDetails(token, permissionId);
          setHasFetched(true);
        } catch (err) {
          setNotification({
            message: `Error fetching permission details: ${err.message}`,
            type: "error",
          });
        }
      }
    };
    fetchDetails();
  }, [token, permissionId, hasFetched, fetchPermissionDetails]);

  const handleUpdatePermissionWithGranularData = async (data) => {
    try {
      await editPermission(token, permissionId, {
        name: data.name,
        permissions: data.permissions || {},
      });
      navigate(getRoleBasedRouteLocal("/admin/permissions"), {
        state: { successMessage: "Permission updated successfully." },
      });
    } catch (err) {
      setNotification({
        message: `Failed to update permission: ${err.message}`,
        type: "error",
      });
    }
  };

  if (!hasFetched || !currentPermission) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="w-full">
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
      <div className="p-4 md:p-6 lg:p-8 max-w-[1500px] mx-auto">
        <button
          type="button"
          onClick={() => navigate(getRoleBasedRouteLocal("/admin/permissions"))}
          className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 font-medium mb-6 transition-colors group"
        >
          <FaArrowLeft className="group-hover:-translate-x-1 transition-transform" />
          Back to Permissions
        </button>

        <RolePermissionsForm
          type="Permission"
          initialName={currentPermission.name}
          initialPermissions={currentPermission.permissions || {}}
          onSave={handleUpdatePermissionWithGranularData}
          onCancel={() =>
            navigate(getRoleBasedRouteLocal("/admin/permissions"))
          }
        />
      </div>
    </div>
  );
};

export default EditPermission;
